import { render, staticRenderFns } from "./LongText.vue?vue&type=template&id=4c1f1edc&scoped=true"
import script from "./LongText.vue?vue&type=script&lang=js"
export * from "./LongText.vue?vue&type=script&lang=js"
import style0 from "./LongText.vue?vue&type=style&index=0&id=4c1f1edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1f1edc",
  null
  
)

export default component.exports